import { useEffect, useState } from 'react';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { checkCertificationCode, unlockCertification } from '@/lib/certification-lock';

type CertificationCodeDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUnlock: () => void;
};

/** Saisie du code d'accès de la rubrique Certification (dialog in-app, jamais window.prompt). */
export function CertificationCodeDialog({
  open,
  onOpenChange,
  onUnlock,
}: CertificationCodeDialogProps) {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (open) {
      setCode('');
      setError(false);
    }
  }, [open]);

  const submit = () => {
    if (!checkCertificationCode(code)) {
      setError(true);
      setCode('');
      return;
    }
    unlockCertification();
    onUnlock();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Lock className="h-5 w-5 text-amber-500" /> Certification
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Saisissez le code d’accès de la rubrique Certification.
        </p>
        <Input
          type="password"
          inputMode="numeric"
          autoFocus
          maxLength={8}
          value={code}
          onChange={(e) => {
            setCode(e.target.value.replace(/\D/g, ''));
            setError(false);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') submit();
          }}
          className="text-center text-2xl tracking-[0.5em]"
          aria-label="Code d’accès"
        />
        {error && <p className="text-sm text-destructive">Code incorrect.</p>}
        <Button onClick={submit} disabled={code.length < 4} className="w-full">
          Déverrouiller
        </Button>
      </DialogContent>
    </Dialog>
  );
}
